var React = require('react');

function Chat (props) {
    return React.createElement("svg",props,React.createElement("g",{"fillRule":"evenodd","transform":"translate(0 -1)"},[React.createElement("path",{"fillRule":"nonzero","d":"M16.492 16.539a1 1 0 0 1 .087-.99A7.94 7.94 0 0 0 18 11.002a8 8 0 1 0-3.716 6.743 1 1 0 0 1 .769-.128l2.176.521-.737-1.6zm2.047-.336l1.37 2.968a1 1 0 0 1-1.142 1.392l-3.781-.905A10 10 0 1 1 20 11a9.94 9.94 0 0 1-1.46 5.203z","key":0}),React.createElement("rect",{"width":"8","height":"2","x":"6","y":"8","rx":"1","key":1}),React.createElement("rect",{"width":"6","height":"2","x":"6","y":"12","rx":"1","key":2})]));
}

Chat.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20"};

module.exports = Chat;

Chat.default = Chat;
